import styled from 'styled-components';

export default styled.div`
  display: flex;
  flex-direction: ${({direction}) => direction ? direction : 'row'};
  justify-content: ${({justifyContent}) => justifyContent ? justifyContent : 'center'};;
  width: 410px;
  margin: ${props => props.margin ? props.margin : 'auto'};
  padding: ${props => props.padding ? props.padding : 'auto'};
  height: ${props => props.height ? props.height : 'auto'};
  box-sizing: border-box;
  
  @media (max-width: 430px) {
    width: 100%;
    padding-left: 20px;
    padding-right: 20px;
  }
`;